import { useEffect, useState } from 'react'
import { fetchBerThongPlayConfig } from '../services/berThongService'

/** แสดงแท็บเบอร์ทองเมื่อ platform เปิด + master switch */
export function useBerThongUserEntry(berThongEnabled?: boolean) {
  const [userEntryVisible, setUserEntryVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    let cancelled = false

    void (async () => {
      if (berThongEnabled !== true) {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
        return
      }

      try {
        const res = await fetchBerThongPlayConfig()
        if (!cancelled) {
          setUserEntryVisible(res.data?.userEntryVisible === true)
          setChecked(true)
        }
      } catch {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [berThongEnabled])

  return {
    showBerThongEntry: berThongEnabled === true && userEntryVisible,
    checked,
  }
}
